import {manageModal} from '@js/modules/modal';

import {userStore} from '@js/stores/userStore';


export function initializeConnection() {
    const isUserConnected = !!window.currentUserId;

    userStore.isConnected = isUserConnected;

    if (isUserConnected) {
        return;
    }

    const SignupForm = () => import('@js/components/layouts/signup');
    const LoginForm = () => import('@js/components/layouts/login');

    const signupModal = manageModal('signup-modal', SignupForm, {
        preloadTime: 1500
    });
    const loginModal = manageModal('login-modal', LoginForm, {
        preloadTime: 1500
    });

    userStore.signupModal = signupModal;
    userStore.loginModal = loginModal;
}
